export const MealPlanServes = {
  bindings: {
    recipe: '<',
    onAddRecipe: '&',
    onClose: '&',
  },

  template: `
    <div class="meal-plan-serves d-flex align-items-center justify-content-center">
      <div class="content text-center">
        <p class="mb-0">
          <small>How many serves?</small>
        </p>
        <button class="btn btn-pill btn-primary border-0 ml-1 py-1"
          ng-repeat="item in $ctrl.recipe.variations | orderBy: 'serves' track by $index"
          ng-click="$ctrl.onAddRecipe({ recipeId: item.id, leftOvers: false })">
          <i class="fa icon-serves text-white"></i>x{{ item.serves }}
        </button>
        <button class="btn btn-pill bg-white border border-green-dark py-1"
          ng-click="$ctrl.onAddRecipe({ recipeId: $ctrl.recipe.id, leftOvers: true })">
          <small class="text-green-dark">Leftovers</small>
        </button>
      </div>
      <div class="meta">
        <button class="btn btn-link p-0"
          ng-click="$ctrl.onClose()">
          <i class="fa fa-2x fa-times-circle m-0"></i>
        </button>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanServes.js